import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";

// Material Dashboard 2 React components
import MDBox from "../../MDBox";
import MDTypography from "../../MDTypography";
import MDButton from "../../MDButton";

// Material Dashboard 2 React context
import { useMaterialUIController } from "../../../context";

import cimbeoLogo from "../../../assets/images/small-logos/cimbeo_logo.png";

function AuthNavbar({ transparent, light }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <Container>
      <MDBox
        py={1}
        px={3}
        my={3}
        mx={3}
        width="calc(100% - 48px)"
        borderRadius="lg"
        shadow={transparent ? "none" : "md"}
        color={light ? "white" : "dark"}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        position="absolute"
        left={0}
        zIndex={3}
        sx={({
          palette: { transparent: transparentColor, white, background, olive_green, navy },
          functions: { rgba },
        }) => ({
          backgroundColor: transparent
            ? transparentColor.main
            : darkMode ? "navy.main" : "slate_gray.main",
          backdropFilter: transparent ? "none" : `saturate(200%) blur(30px)`,
          border: transparent ? "none" : "1px solid rgba(0, 0, 0, 0.05)",
        })}
      >
        <MDBox
          component={Link}
          to="/"
          py={0.75}
          lineHeight={1}
          display="flex"
          alignItems="center"
          gap={2}
        >
          <Avatar 
            src={cimbeoLogo}
            alt="Cimbeo Logo"
            sx={{ width: 40, height: 40 }}
          />
          <MDTypography variant="h3" fontWeight="bold">
            CIMBEO
          </MDTypography>
        </MDBox>
        <MDButton
          component="a"
          href="https://cimbeo.com"
          target="_blank"
          rel="noreferrer"
          variant="gradient"
          size="small"
          sx={{ mt: -0.3 }}
        >
          About
        </MDButton>
      </MDBox>
    </Container>
  );
}

// Setting default values for the props of AuthNavbar
AuthNavbar.defaultProps = {
  transparent: false,
  light: false,
};

// Typechecking props for the AuthNavbar
AuthNavbar.propTypes = {
  transparent: PropTypes.bool,
  light: PropTypes.bool,
};

export default AuthNavbar;
